var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 56,
    viewBox: "0 0 72 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 56,
    rx: 16,
    fill: "#00ABFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 36H45",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2603 17.5992L29.0503 26.2892C28.7403 26.6192 28.4403 27.2692 28.3803 27.7192L28.0103 30.9592C27.8803 32.1292 28.7203 32.9292 29.8803 32.7292L33.1003 32.1792C33.5503 32.0992 34.1803 31.7692 34.4903 31.4292L42.7003 22.7392C44.1203 21.2392 44.7603 19.5292 42.5503 17.4392C40.3503 15.3692 38.6803 16.0992 37.2603 17.5992Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8896 19.0488C36.3196 21.8088 38.5596 23.9188 41.3396 24.1988",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTest);
export default __webpack_public_path__ + "static/media/editTest.4e3d299fdaf55e58f8e5ce19d6607d34.svg";
export { ForwardRef as ReactComponent };